import { render, staticRenderFns } from "./JobOpportunitiesPage.vue?vue&type=template&id=2f2728b0&"
import script from "./JobOpportunitiesPage.vue?vue&type=script&lang=js&"
export * from "./JobOpportunitiesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports